import type { GetterClass, IndexJobDTO, IndexState } from '../../../models'

export class JobsGetter implements GetterClass {
  static execute(this: void, state: IndexState): Array<IndexJobDTO> {
    return state.jobs
  }
}
